const styleVar = {
  fontMain: `'Lexend', Helevetica, sans-serif;`,
  fontHeading: `'Barlow Condensed', Helvetica, sans-serif;`,

  color_1: `#313238`,
  color_1_hov: `#50525c`,

  bpXs: 420,
  bpSm: 576,
  bpMd: 768,
  bpLg: 1024,
  bpXl: 1280,
}

export default styleVar
